import { LoadableAfterPaint } from '@confluence/loadable';

export const InconsistentLicenseFlag = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InconsistentLicenseFlag" */ '../src/InconsistentLicenseFlag.tsx'
			)
		).InconsistentLicenseFlag,
});
